export default __webpack_public_path__ + "static/media/bar-allowances.2fcb043f.svg";